import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Button, Text} from '@chakra-ui/react3'
import {Notification01Icon} from '../../../../../leap/components/icons'

const NotifyMeBtn = ({onClick, showLabel = true, ...props}) => {
    const {formatMessage} = useIntl()
    const notifyLabel = formatMessage({
        id: 'notify.modal.submit',
        defaultMessage: 'Notify me'
    })

    return (
        <Button
            variant="secondaryOutline"
            size="lg"
            onClick={(e) => {
                onClick?.()
                e?.preventDefault?.()
                e?.stopPropagation?.()
            }}
            aria-label={notifyLabel}
            {...props}
        >
            {showLabel && <Text>{notifyLabel}</Text>}
            <Notification01Icon />
        </Button>
    )
}

NotifyMeBtn.propTypes = {
    product: PropTypes.object,
    onClick: PropTypes.func,
    showLabel: PropTypes.bool
}

export default NotifyMeBtn
